export interface Movie {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  year: number;
  rating: number;
  description: string;
  image: string;
  tags: string[];
  updateTime: string;
  views: number;
  director: string;
  actors: string[];
  region: string;
  duration: string;
  content: string;
}

export const categories = [
  { name: '电影', slug: 'movie', icon: 'ri-film-line' },
  { name: '电视剧', slug: 'tv', icon: 'ri-tv-line' },
  { name: '综艺', slug: 'variety', icon: 'ri-live-line' },
  { name: '动漫', slug: 'anime', icon: 'ri-rocket-line' },
  { name: '纪录片', slug: 'documentary', icon: 'ri-camera-line' },
];

export const hotMovies: Movie[] = [
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.7,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类再次踏上漫长的星际流浪之旅，在浩瀚宇宙中寻找新家园。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20epic%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20clean%20and%20modern%20aesthetic%2C%20professional%20movie%20poster%20style%20with%20warm%20orange%20and%20teal%20tones&width=800&height=450&seq=movie-hot-01&orientation=landscape',
    tags: ['科幻', '冒险', '灾难', '热门'],
    updateTime: '2026-08-03',
    views: 12580000,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '148分钟',
    content: '《流浪地球3》延续前作宏大的科幻世界观，讲述了太阳急速老化膨胀的危机下，人类再次面临生存抉择。地球联合政府启动了"流浪地球计划"的第三阶段，人类文明在宇宙中的命运悬于一线。影片融合了硬核科幻与东方家国情怀，以惊人的视觉特效和深刻的人性思考，为观众呈现了一场跨越星际的壮丽史诗。',
  },
  {
    id: 2,
    title: '长安三万里2',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.1,
    description: '盛唐风华再现，诗人李白与高适的传奇故事继续上演，一段跨越时空的文化寻根之旅。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20animated%20film%20scene%20with%20poets%20and%20beautiful%20traditional%20architecture%2C%20warm%20golden%20sunset%20lighting%2C%20artistic%20Chinese%20painting%20style%2C%20elegant%20composition%20with%20flying%20petals%20and%20soft%20atmosphere&width=800&height=450&seq=movie-hot-02&orientation=landscape',
    tags: ['动画', '历史', '文化', '热映'],
    updateTime: '2026-07-28',
    views: 9800000,
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    content: '《长安三万里2》以安史之乱后的唐朝为背景，继续讲述高适与李白两位大诗人的命运交织。影片以瑰丽的国风动画呈现了长安城的繁华与凋零，通过诗人们的视角，展现了一个大时代下个体命运的沉浮与坚守，是对中华文化精神的一次深情致敬。',
  },
  {
    id: 3,
    title: '封神第二部',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.5,
    description: '殷商大战全面爆发，姜子牙率众神迎战，封神榜上英雄辈出，一场荡气回肠的神话史诗。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythology%20fantasy%20film%20scene%20with%20ancient%20warriors%20and%20magical%20creatures%2C%20dramatic%20battle%20scene%2C%20cinematic%20lighting%20with%20golden%20and%20crimson%20tones%2C%20grand%20scale%20composition&width=800&height=450&seq=movie-hot-03&orientation=landscape',
    tags: ['奇幻', '动作', '神话', '大片'],
    updateTime: '2026-07-15',
    views: 15800000,
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤'],
    region: '中国大陆',
    duration: '155分钟',
    content: '《封神第二部》承接前作，殷商与西岐的战争全面爆发。姜子牙率领众神与凡人英雄迎战殷商大军，封神榜上的名字逐一显现。影片以震撼的视觉奇观和深厚的情感内核，重塑了中国古典神话的现代叙事。',
  },
  {
    id: 4,
    title: '独行月球2：重返',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.3,
    description: '独孤月从月球归来后，人类再次面临太空危机，这次他不再独行，但挑战更加艰巨。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20comedy%20film%20scene%20on%20moon%20surface%20with%20astronaut%20character%2C%20bright%20and%20humorous%20tone%2C%20cinematic%20space%20backdrop%20with%20Earth%20rising%2C%20warm%20lighting%2C%20clean%20composition&width=800&height=450&seq=movie-hot-04&orientation=landscape',
    tags: ['科幻', '喜剧', '冒险'],
    updateTime: '2026-08-01',
    views: 7200000,
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦'],
    region: '中国大陆',
    duration: '132分钟',
    content: '《独行月球2：重返》讲述了独孤月回归地球后的新冒险。当一颗更大的小行星威胁地球时，独孤月不得不再次踏上太空之旅。这一次他不再独行，但面对的是更加艰巨的挑战。影片延续了前作的喜剧风格，同时加入了更多温情的元素。',
  },
  {
    id: 5,
    title: '狂飙：电影版',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.3,
    description: '高启强与安欣的终极对决在大银幕上震撼上演，一场正邪较量重新定义警匪片新高度。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20film%20scene%20with%20two%20men%20facing%20off%20in%20Chinese%20city%20at%20night%2C%20rainy%20streets%2C%20neon%20lights%2C%20intense%20atmosphere%2C%20cinematic%20color%20grading%20with%20deep%20blues%20and%20warm%20accents&width=800&height=450&seq=movie-hot-05&orientation=landscape',
    tags: ['犯罪', '剧情', '动作', '口碑'],
    updateTime: '2026-07-20',
    views: 21000000,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    duration: '142分钟',
    content: '《狂飙：电影版》将电视剧的经典故事浓缩升级，在大银幕上呈现高启强与安欣二十年恩怨的终极对决。影片以更加紧凑的叙事和精湛的表演，深入挖掘了人性的复杂与社会的变迁，是一部兼具商业性与艺术性的警匪巨制。',
  },
  {
    id: 6,
    title: '哪吒之魔童闹海2',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.0,
    description: '哪吒与敖丙再续前缘，一场惊天动地的海底冒险开启，国漫巅峰之作华丽回归。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20scene%20with%20mythological%20dragon%20and%20young%20hero%20character%2C%20underwater%20palace%20setting%2C%20vibrant%20colors%20and%20dynamic%20composition%2C%20magical%20lighting%20effects&width=800&height=450&seq=movie-hot-06&orientation=landscape',
    tags: ['动画', '奇幻', '神话', '国漫'],
    updateTime: '2026-07-25',
    views: 19200000,
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    duration: '120分钟',
    content: '《哪吒之魔童闹海2》延续了前作的精良制作，讲述了哪吒与敖丙深入东海龙宫的全新冒险。影片在视觉呈现上再次突破，以震撼的3D动画展现了瑰丽的海底世界，同时延续了"我命由我不由天"的精神内核。',
  },
  {
    id: 7,
    title: '隐秘的角落2',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.2,
    description: '全新悬疑故事，三个孩子再次卷入一场无法预料的阴谋，真相隐藏在每一个角落。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20TV%20series%20scene%20in%20Chinese%20small%20town%2C%20three%20children%20looking%20at%20something%20mysterious%2C%20moody%20atmospheric%20lighting%2C%20summer%20vibe%2C%20cinematic%20composition%20with%20warm%20nostalgic%20tones&width=800&height=450&seq=movie-hot-07&orientation=landscape',
    tags: ['悬疑', '剧情', '犯罪', '高分'],
    updateTime: '2026-08-02',
    views: 16800000,
    director: '辛爽',
    actors: ['秦昊', '王景春', '荣梓杉'],
    region: '中国大陆',
    duration: '12集',
    content: '《隐秘的角落2》以全新的故事线展开，延续了前作精妙的悬疑叙事。在一个南方小城里，三个孩子的偶然发现引发了一连串不可预料的连锁反应。影片以细腻的镜头语言和层层递进的悬念设置，再次证明了国产悬疑剧的高水准。',
  },
  {
    id: 8,
    title: '庆余年第三季',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.4,
    description: '范闲的身份之谜逐渐揭晓，朝堂之上暗流涌动，江湖之中刀光剑影。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20scene%20with%20ancient%20palace%20and%20warriors%2C%20elegant%20costumes%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20epic%20composition&width=800&height=450&seq=movie-hot-08&orientation=landscape',
    tags: ['古装', '权谋', '奇幻', '热播'],
    updateTime: '2026-07-30',
    views: 23500000,
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
    duration: '36集',
    content: '《庆余年第三季》中，范闲的身世之谜终于揭晓，各方势力围绕他的真实身份展开了一场惊心动魄的博弈。朝堂权谋与江湖恩怨交织，范闲在守护所爱之人的同时，也必须面对自己命运的选择。',
  },
];

export const latestUpdates: Movie[] = [
  {
    id: 9,
    title: '三体：黑暗森林',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.5,
    description: '面壁计划启动，罗辑成为关键人物，人类文明在黑暗森林法则下面临终极考验。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20scene%20with%20cosmic%20scale%2C%20deep%20space%20and%20futuristic%20technology%2C%20dark%20and%20mysterious%20atmosphere%2C%20cinematic%20quality%20with%20starry%20background%2C%20professional%20lighting&width=800&height=450&seq=movie-update-01&orientation=landscape',
    tags: ['科幻', '剧情', '悬疑', '新剧'],
    updateTime: '2026-08-03',
    views: 5800000,
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    region: '中国大陆',
    duration: '30集',
    content: '《三体：黑暗森林》改编自刘慈欣同名小说，聚焦面壁计划的启动与实施。罗辑被选为面壁者之一，在看似荒唐的表象下，隐藏着对抗三体文明的终极策略。影片以宏大的宇宙尺度和精密的科学逻辑，呈现了人类文明在黑暗森林法则下的艰难抉择。',
  },
  {
    id: 10,
    title: '繁花似锦',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 8.8,
    description: '90年代上海，一群年轻人在改革开放浪潮中追逐梦想，爱情与事业交织的时代画卷。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20TV%20drama%20set%20in%201990s%20Shanghai%2C%20young%20couple%20on%20busy%20street%20with%20vintage%20cars%20and%20neon%20signs%2C%20romantic%20atmosphere%2C%20warm%20nostalgic%20color%20palette%2C%20cinematic%20quality&width=800&height=450&seq=movie-update-02&orientation=landscape',
    tags: ['都市', '爱情', '年代', '热播'],
    updateTime: '2026-08-02',
    views: 4200000,
    director: '王家卫',
    actors: ['胡歌', '马伊琍', '唐嫣'],
    region: '中国大陆',
    duration: '24集',
    content: '《繁花似锦》以90年代的上海为背景，讲述了在改革开放大潮中，一群年轻人在外滩的繁华与弄堂的烟火间追逐梦想的故事。王家卫导演以独特的影像风格，将那个充满希望与迷茫的时代娓娓道来。',
  },
  {
    id: 11,
    title: '乘风破浪的姐姐5',
    category: '综艺',
    categorySlug: 'variety',
    year: 2026,
    rating: 8.6,
    description: '全新阵容，更多挑战，姐姐们在舞台上绽放无限光彩，诠释女性力量的华丽篇章。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20variety%20show%20stage%20performance%20with%20female%20singers%20and%20dancers%2C%20colorful%20stage%20lighting%2C%20dynamic%20and%20energetic%20atmosphere%2C%20professional%20production%20quality&width=800&height=450&seq=movie-update-03&orientation=landscape',
    tags: ['综艺', '音乐', '竞演', '热门'],
    updateTime: '2026-08-03',
    views: 3500000,
    director: '芒果TV',
    actors: ['那英', '宁静', '王心凌'],
    region: '中国大陆',
    duration: '12期',
    content: '《乘风破浪的姐姐5》再度集结华语乐坛实力女艺人，以全新的赛制和更具挑战性的舞台表演，展现姐姐们的多面才华。本季在保留经典模式的基础上，加入了更多跨界合作与创新元素。',
  },
  {
    id: 12,
    title: '斗罗大陆2：绝世唐门',
    category: '动漫',
    categorySlug: 'anime',
    year: 2026,
    rating: 9.0,
    description: '霍雨浩的传奇旅程开启，绝世唐门的故事在万年后重新演绎，魂师世界的新篇章。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%203D%20anime%20fantasy%20scene%20with%20young%20martial%20arts%20hero%20and%20magical%20spirit%20beasts%2C%20bright%20and%20colorful%20visuals%2C%20dynamic%20action%20pose%2C%20epic%20fantasy%20world%20background&width=800&height=450&seq=movie-update-04&orientation=landscape',
    tags: ['动漫', '奇幻', '热血', '更新中'],
    updateTime: '2026-08-03',
    views: 2800000,
    director: '玄机科技',
    actors: ['张杰', '乔诗语', '季冠霖'],
    region: '中国大陆',
    duration: '52集',
    content: '《斗罗大陆2：绝世唐门》延续了斗罗系列的世界观，故事发生在唐三飞升万年之后。少年霍雨浩带着灵眸武魂踏入史莱克学院，一段全新的传奇就此展开。玄机科技以顶级的3D动画制作，为观众呈现了一个更加宏大的魂师世界。',
  },
  {
    id: 13,
    title: '舌尖上的中国5',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2026,
    rating: 9.3,
    description: '跨越山河湖海，探寻中国美食的灵魂所在，每一道菜都是一段温暖人心的故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20rustic%20Chinese%20village%20setting%2C%20appetizing%20food%20photography%20style&width=800&height=450&seq=movie-update-05&orientation=landscape',
    tags: ['纪录片', '美食', '人文', '高分'],
    updateTime: '2026-08-01',
    views: 6500000,
    director: '陈晓卿',
    actors: ['李立宏'],
    region: '中国大陆',
    duration: '8集',
    content: '《舌尖上的中国5》将镜头对准中国各地的家常味道，从东北的酸菜炖粉条到广东的老火靓汤，每一集都深入一个普通家庭的厨房，用美食串联起中国人的情感记忆与文化传承。',
  },
  {
    id: 14,
    title: '白夜追凶2',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 8.9,
    description: '关宏峰兄弟再次联手，新的连环案件扑朔迷离，真相永远藏于白夜之间。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20thriller%20drama%20scene%20at%20night%2C%20detective%20investigating%20in%20dark%20alley%2C%20moody%20noir%20lighting%2C%20suspenseful%20atmosphere%2C%20professional%20cinematic%20quality&width=800&height=450&seq=movie-update-06&orientation=landscape',
    tags: ['悬疑', '犯罪', '剧情', '回归'],
    updateTime: '2026-07-29',
    views: 11200000,
    director: '王伟',
    actors: ['潘粤明', '王泷正', '梁缘'],
    region: '中国大陆',
    duration: '30集',
    content: '《白夜追凶2》时隔多年再度回归，关宏峰与关宏宇兄弟继续以"白夜"模式追查真相。这一次，他们面对的是一个更加复杂和危险的犯罪网络，而过去的阴影也在悄然逼近。',
  },
];

export const rankingMovies: Movie[] = [
  {
    id: 5,
    title: '狂飙：电影版',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.3,
    description: '高启强与安欣的终极对决在大银幕上震撼上演，一场正邪较量重新定义警匪片新高度。',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20film%20scene%20with%20two%20men%20facing%20off%20in%20Chinese%20city%20at%20night%2C%20rainy%20streets%2C%20neon%20lights%2C%20intense%20atmosphere%2C%20cinematic%20color%20grading%20with%20deep%20blues%20and%20warm%20accents&width=800&height=450&seq=movie-rank-01&orientation=landscape',
    tags: ['犯罪', '剧情', '动作'],
    updateTime: '2026-07-20',
    views: 21000000,
    director: '徐纪周',
    actors: ['张译', '张颂文', '李一桐'],
    region: '中国大陆',
    duration: '142分钟',
    content: '',
  },
  {
    id: 8,
    title: '庆余年第三季',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.4,
    description: '范闲的身份之谜逐渐揭晓，朝堂之上暗流涌动，江湖之中刀光剑影。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20fantasy%20drama%20scene%20with%20ancient%20palace%20and%20warriors%2C%20elegant%20costumes%2C%20cinematic%20lighting%20with%20warm%20golden%20and%20deep%20red%20tones%2C%20epic%20composition&width=800&height=450&seq=movie-rank-02&orientation=landscape',
    tags: ['古装', '权谋', '奇幻'],
    updateTime: '2026-07-30',
    views: 23500000,
    director: '孙皓',
    actors: ['张若昀', '李沁', '陈道明'],
    region: '中国大陆',
    duration: '36集',
    content: '',
  },
  {
    id: 7,
    title: '隐秘的角落2',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.2,
    description: '全新悬疑故事，三个孩子再次卷入一场无法预料的阴谋，真相隐藏在每一个角落。',
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20TV%20series%20scene%20in%20Chinese%20small%20town%2C%20three%20children%20looking%20at%20something%20mysterious%2C%20moody%20atmospheric%20lighting%2C%20summer%20vibe%2C%20cinematic%20composition%20with%20warm%20nostalgic%20tones&width=800&height=450&seq=movie-rank-03&orientation=landscape',
    tags: ['悬疑', '剧情', '犯罪'],
    updateTime: '2026-08-02',
    views: 16800000,
    director: '辛爽',
    actors: ['秦昊', '王景春', '荣梓杉'],
    region: '中国大陆',
    duration: '12集',
    content: '',
  },
  {
    id: 6,
    title: '哪吒之魔童闹海2',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.0,
    description: '哪吒与敖丙再续前缘，一场惊天动地的海底冒险开启，国漫巅峰之作华丽回归。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20animated%20fantasy%20film%20scene%20with%20mythological%20dragon%20and%20young%20hero%20character%2C%20underwater%20palace%20setting%2C%20vibrant%20colors%20and%20dynamic%20composition%2C%20magical%20lighting%20effects&width=800&height=450&seq=movie-rank-04&orientation=landscape',
    tags: ['动画', '奇幻', '神话'],
    updateTime: '2026-07-25',
    views: 19200000,
    director: '饺子',
    actors: ['吕艳婷', '囧森瑟夫', '瀚墨'],
    region: '中国大陆',
    duration: '120分钟',
    content: '',
  },
  {
    id: 2,
    title: '长安三万里2',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 9.1,
    description: '盛唐风华再现，诗人李白与高适的传奇故事继续上演，一段跨越时空的文化寻根之旅。',
    image: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20Dynasty%20animated%20film%20scene%20with%20poets%20and%20beautiful%20traditional%20architecture%2C%20warm%20golden%20sunset%20lighting%2C%20artistic%20Chinese%20painting%20style%2C%20elegant%20composition%20with%20flying%20petals%20and%20soft%20atmosphere&width=800&height=450&seq=movie-rank-05&orientation=landscape',
    tags: ['动画', '历史', '文化'],
    updateTime: '2026-07-28',
    views: 9800000,
    director: '谢君伟',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    region: '中国大陆',
    duration: '168分钟',
    content: '',
  },
  {
    id: 13,
    title: '舌尖上的中国5',
    category: '纪录片',
    categorySlug: 'documentary',
    year: 2026,
    rating: 9.3,
    description: '跨越山河湖海，探寻中国美食的灵魂所在，每一道菜都是一段温暖人心的故事。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20steaming%20hot%20traditional%20dishes%20on%20wooden%20table%2C%20warm%20kitchen%20lighting%2C%20rustic%20Chinese%20village%20setting%2C%20appetizing%20food%20photography%20style&width=800&height=450&seq=movie-rank-06&orientation=landscape',
    tags: ['纪录片', '美食', '人文'],
    updateTime: '2026-08-01',
    views: 6500000,
    director: '陈晓卿',
    actors: ['李立宏'],
    region: '中国大陆',
    duration: '8集',
    content: '',
  },
  {
    id: 9,
    title: '三体：黑暗森林',
    category: '电视剧',
    categorySlug: 'tv',
    year: 2026,
    rating: 9.5,
    description: '面壁计划启动，罗辑成为关键人物，人类文明在黑暗森林法则下面临终极考验。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20TV%20series%20scene%20with%20cosmic%20scale%2C%20deep%20space%20and%20futuristic%20technology%2C%20dark%20and%20mysterious%20atmosphere%2C%20cinematic%20quality%20with%20starry%20background%2C%20professional%20lighting&width=800&height=450&seq=movie-rank-07&orientation=landscape',
    tags: ['科幻', '剧情', '悬疑'],
    updateTime: '2026-08-03',
    views: 5800000,
    director: '杨磊',
    actors: ['张鲁一', '于和伟', '陈瑾'],
    region: '中国大陆',
    duration: '30集',
    content: '',
  },
  {
    id: 1,
    title: '流浪地球3',
    category: '电影',
    categorySlug: 'movie',
    year: 2026,
    rating: 8.7,
    description: '太阳急速老化，持续膨胀，地球面临被吞没的灭顶之灾。人类再次踏上漫长的星际流浪之旅。',
    image: 'https://readdy.ai/api/search-image?query=Sci-fi%20movie%20scene%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20epic%20cinematic%20lighting%2C%20dramatic%20atmosphere%2C%20clean%20and%20modern%20aesthetic%2C%20professional%20movie%20poster%20style%20with%20warm%20orange%20and%20teal%20tones&width=800&height=450&seq=movie-rank-08&orientation=landscape',
    tags: ['科幻', '冒险', '灾难'],
    updateTime: '2026-08-03',
    views: 12580000,
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健'],
    region: '中国大陆',
    duration: '148分钟',
    content: '',
  },
];

export const aboutInfo = {
  brandName: '糖心影视',
  slogan: '甜蜜观影，从糖心开始',
  founded: '2018年',
  description: '糖心影视成立于2018年，是一家专注于高清影视内容聚合与分发的互联网平台。我们致力于为全球华语用户提供海量正版影视资源的在线观看服务，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。',
  mission: '让每个人都能随时随地享受高品质的观影体验，用光影传递温暖与感动。',
  vision: '成为华语世界最受欢迎的影视内容平台，打造连接创作者与观众的数字桥梁。',
  stats: [
    { label: '影片资源', value: '100,000+' },
    { label: '日活用户', value: '500万+' },
    { label: '累计播放', value: '100亿+' },
    { label: '内容分类', value: '20+' },
  ],
  contact: {
    email: 'contact@tangxinys.com',
    phone: '400-888-6666',
    address: '北京市朝阳区望京SOHO T3 18层',
    wechat: 'tangxinys',
    weibo: '@糖心影视官方',
  },
};

export const allMovies: Movie[] = [...hotMovies, ...latestUpdates.filter(m => !hotMovies.find(h => h.id === m.id))];